/* eslint-disable */
import style from "./skeleton.module.scss";

const Skeleton = ({ className, ...props }) => {
  return <div {...props} className={`${className} ${style.ROOT}`} />;
};
Skeleton.Item = ({ className, circle, ...props }) => {
  return (
    <div
      {...props}
      className={`${className} ${(circle && style.circle) || ""} ${style.item}`}
    />
  );
};
Skeleton.Text = ({ className, ...props }) => {
  return (
    <div className={style.text}>
      <div {...props} className={`${className}  ${style.item}`} />
    </div>
  );
};

export default Skeleton;
